import { useMemo } from "react";
import { useApolloClient } from "@apollo/client";

import { useAppDispatch, useAppSelector } from "../../../Store";

import { gqlActions } from "../gqlData_Reducer";
import Graph_QL, { GqlHook_Returns, StateDataObject } from "..";
import { noop } from "lodash";
import { filterByConnection } from "../filterByConnection";
import { FeedCurveSettingsItem } from "./FeedDataSlices/feedCurveSettingsSlice";
import { FeedCurveSettingsResponse, GET_FEED_CURVE_SETTINGS, UPDATE_FEED_CURVE_SETTINGS } from "./GQLCalls/getFeedCurveSettingsCall";

export const useFeedCurveSettings = (connection: Graph_QL.GQLCons): GqlHook_Returns<FeedCurveSettingsItem, number> => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();

  const feedCurveSettingsState = useAppSelector(({graphQlData:{domain}}) => domain.feedCurveSettings);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(feedCurveSettingsState, Graph_QL.ToArr(connection)) as Record<string, FeedCurveSettingsItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<FeedCurveSettingsItem>)
  },[connection, feedCurveSettingsState]);

  const getFeedCurveSettings = async (specific?: Graph_QL.GQLCons, id?: number) => {
    try {
    await client.query<FeedCurveSettingsResponse>({query: GET_FEED_CURVE_SETTINGS, variables: {...specific?.connection, feedcurveId: id}})
      .then((e) => {
        if (e && e.data) {
        dispatch({type: String(gqlActions.domain.feedCurveSettings.add), payload: {con: connection?.connection, data: e.data.getFeedCurveSettings}});
        }
      })}
      catch (e) {
         dispatch({type: String(gqlActions.domain.feedCurveSettings.add), payload: {con: connection?.connection, data: []}}); 
         // TODO CTO This is only for when graphql fails currently the test data should never be populated in production
      }
    }
  
  const fetchMore = async (cursor: number|number[], specific?: Graph_QL.GQLCons) => {
    }

  const maintainEntries = async (changedData?: Partial<FeedCurveSettingsItem>) => {
   
    try {
      await client.mutate({mutation: UPDATE_FEED_CURVE_SETTINGS, variables: {...connection.connection, updateFeedCurveSettings: changedData?.data}})
        .then((response) => {
          if (response && response.data.updateFeedCurveSettings.success) {
            dispatch({type: String(gqlActions.domain.feedCurveSettings.maintained), payload: {con: connection.connection, data: changedData}})
          }
        })
    } catch (error) {
      console.warn("The update failed -> no changes dispatched");
    }
    // const typeGuardedChangedData = {
    //   con: changedData?.con,
    //   data: changedData?.data?.map((info) => {
    //     return {
    //       ...info,
    //     }
    //   })
    // }
  }

  return {call: getFeedCurveSettings, fetchMore, deleteEntries: noop, data: fullState, maintainEntries}
} 

